import { ChangeEvent, FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { isNotEmpty, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { Company, initialService, Service } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { ServicesListLoading } from '../components/loading/ServicesListLoading'
import { createService, updateService } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { FormattedMessage, useIntl } from 'react-intl'
import { ServiceCategory } from '../../../service-category/service-categories-list/core/_models'
import axios from 'axios'

type Props = {
  isServiceLoading: boolean
  service: Service
}

const editServiceSchema = Yup.object().shape({
  profile_image_url: Yup.mixed(),
})

const ServiceEditModalForm: FC<Props> = ({ service, isServiceLoading }) => {
  const API_URL = process.env.REACT_APP_THEME_API_URL;
  const COMPANY_URL = `${API_URL}/admin/companies`;
  const SERVICE_CATEGORY_URL = `${API_URL}/admin/service_categories`;
  const intl = useIntl()
  // Function to handle image selection
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // Function to handle image selection
  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const imageURL = URL.createObjectURL(file);
      setSelectedImage(imageURL);

    }
  };

  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()
  const [companies, setCompanies] = useState<[Company]>();
  const [service_categories, setServiceCategories] = useState<[ServiceCategory]>();
  useEffect(() => {
    // Make the API request using Axios
    //get companies
    axios
      .get(COMPANY_URL)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setCompanies(data.data.companies);
        }
      })
      .catch((error) => {
        console.error(error);
      });
      //get provinces
      axios
      .get(SERVICE_CATEGORY_URL)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setServiceCategories(data.data.servicecategories);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const [serviceForEdit] = useState<Service>({
    ...service,
    service_name: service.service_name || initialService.service_name,
    service_category: service.service_category?.id || initialService.service_category?.id,
    company:service.company?.id || initialService.company?.id
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const formik = useFormik({
    initialValues: serviceForEdit,
    validationSchema: editServiceSchema,
    onSubmit: async (values, { setSubmitting }) => {
      console.log("form values", values);
      setSubmitting(true)
      try {
        if (isNotEmpty(values.id)) {
          await updateService(values)
        } else {
          await createService(values)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  return (
    <>
      <form id='kt_modal_add_service_form' encType="multipart/form-data" className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_service_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_service_header'
          data-kt-scroll-wrappers='#kt_modal_add_service_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'><FormattedMessage id='SERVICE.FORM.INPUT.SERVICENAME' />
            </label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder={intl.formatMessage({ id: 'SERVICE.FORM.PLACEHOLDER.SERVICENAME' })}
              {...formik.getFieldProps('service_name')}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.service_name && formik.errors.service_name },
                {
                  'is-valid': formik.touched.service_name && !formik.errors.service_name,
                }
              )}
              type='text'
              name='service_name'
              autoComplete='off'
              disabled={formik.isSubmitting || isServiceLoading}
            />
            {/* end::Input */}
            {formik.touched.service_name && formik.errors.service_name && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.service_category}</span> */}
              </div>
            )}
          </div>
          {/* end::Input group */}
          {/* begin::Input group */}

          <div className="fv-row mb-10"><label className="form-label required">
            <FormattedMessage id='SERVICE.FORM.INPUT.COMPANY' />
          </label>
            <select
              {...formik.getFieldProps('company_id')}
              className={clsx(
                'form-select form-select-lg form-select-solid form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.service_category && formik.errors.service_category },
                {
                  'is-valid': formik.touched.service_category && !formik.errors.service_category,
                }
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isServiceLoading}

            ><option value='' defaultValue={""}>{intl.formatMessage({ id: 'FORM.GENERAL.SELECT' })}</option>
              {companies && companies.map(company => (
                <option value={company.id}>{company.company_name}</option>
              ))}
            </select>
            {formik.touched.company && formik.errors.company && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.service_id}</span> */}
              </div>
            )}</div>
          {/* end::Input group */}
          {/* begin::Input group */}

          <div className="fv-row mb-10"><label className="form-label required">
            <FormattedMessage id='SERVICE.FORM.INPUT.SERVICECATEGORY' />
          </label>
            <select
              {...formik.getFieldProps('service_category_id')}
              className={clsx(
                'form-select form-select-lg form-select-solid form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.service_category && formik.errors.service_category },
                {
                  'is-valid': formik.touched.service_category && !formik.errors.service_category,
                }
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isServiceLoading}

            ><option value='' defaultValue={""}>{intl.formatMessage({ id: 'FORM.GENERAL.SELECT' })}</option>
              {service_categories && service_categories.map(service_category => (
                <option value={service_category.id}>{service_category.category_name}</option>
              ))}
            </select>
            {formik.touched.service_category && formik.errors.service_category && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.service_id}</span> */}
              </div>
            )}</div>
          {/* end::Input group */}

        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-services-modal-action='cancel'
            disabled={formik.isSubmitting || isServiceLoading}
          >
            <FormattedMessage id='FORM.GENERAL.DISCARD' />
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-services-modal-action='submit'
            disabled={isServiceLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isServiceLoading) && (
              <span className='indicator-progress'>
                <FormattedMessage id='FORM.GENERAL.PLEASEWAIT' />
                {' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isServiceLoading) && <ServicesListLoading />}
    </>
  )
}

export { ServiceEditModalForm }
